/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SpeciesStatus } from './SpeciesStatus';
import {
    SpeciesStatusFromJSON,
    SpeciesStatusFromJSONTyped,
    SpeciesStatusToJSON,
    SpeciesStatusToJSONTyped,
} from './SpeciesStatus';
import type { SpeciesPrediction } from './SpeciesPrediction';
import {
    SpeciesPredictionFromJSON,
    SpeciesPredictionFromJSONTyped,
    SpeciesPredictionToJSON,
    SpeciesPredictionToJSONTyped,
} from './SpeciesPrediction';

/**
 * Server-side (Fishial) species classification. Surfaced in the catch table
 * (top-1, overridden by the human annotation species) and the detail panel
 * (top-3 with confidences). Scores are cosine similarities, not calibrated
 * probabilities — the model is open-set-blind and always returns a top-k.
 * @export
 * @interface SpeciesResultSchema
 */
export interface SpeciesResultSchema {
    /**
     * 
     */
    status: SpeciesStatus;
    /**
     * 
     */
    predictions: Array<SpeciesPrediction>;
    /**
     * 
     */
    confidence: number | null;
    /**
     * 
     */
    chosenFrameIndex: number | null;
}



/**
 * Check if a given object implements the SpeciesResultSchema interface.
 */
export function instanceOfSpeciesResultSchema(value: object): value is SpeciesResultSchema {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('predictions' in value) || value['predictions'] === undefined) return false;
    if (!('confidence' in value) || value['confidence'] === undefined) return false;
    if ((!('chosenFrameIndex' in (value as Record<string, any>)) && !('chosen_frame_index' in (value as Record<string, any>))) || ((value as Record<string, any>)['chosenFrameIndex'] === undefined && (value as Record<string, any>)['chosen_frame_index'] === undefined)) return false;
    return true;
}

export function SpeciesResultSchemaFromJSON(json: any): SpeciesResultSchema {
    return SpeciesResultSchemaFromJSONTyped(json, false);
}

export function SpeciesResultSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpeciesResultSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'status': SpeciesStatusFromJSON(json['status']),
        'predictions': ((json['predictions'] as Array<any>).map(SpeciesPredictionFromJSON)),
        'confidence': json['confidence'],
        'chosenFrameIndex': json['chosen_frame_index'],
    };
}

export function SpeciesResultSchemaToJSON(json: any): SpeciesResultSchema {
    return SpeciesResultSchemaToJSONTyped(json, false);
}

export function SpeciesResultSchemaToJSONTyped(value?: SpeciesResultSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': SpeciesStatusToJSON(value['status']),
        'predictions': ((value['predictions'] as Array<any>).map(SpeciesPredictionToJSON)),
        'confidence': value['confidence'],
        'chosen_frame_index': value['chosenFrameIndex'],
    };
}

